export default [
  {
    path: '/v2/exchange-rates',
    name: 'exchange-rate',
    meta: { requiresAuth: true },
    component: () => import('./views/index.vue')
  }
]
